export const lensAddresses = {
  accountLens: "0xa06b923a85d96c62205fA007435E375e9d0Ce31f",
  eulerEarnVaultLens: "0xb30e10a985a6eE12eff57F172ef6404524c3210b",
  irmLens: "0x227cc7C2DA74bE56A24Df0f4cDFFb7F227fc86f8",
  oracleLens: "0x521E9A23ada57FDfaa4C6272eF26C2c4FE0c0Ee8",
  utilsLens: "0x3f4F2f1536F428D4555C232E0013D0D36a19485A",
  vaultLens: "0xd40DD19eD88a949436f784877A1BB59660ee8DE3",
} as const
